import { useWindowSize } from 'reactApp/hooks/useWindowSize';

// Минимальная ширина модального окна в VKUI
const INTEGRATION_WINDOW_SMALL_SIZE = 430;

export const useIsWindowWidthSmall = (n: number = INTEGRATION_WINDOW_SMALL_SIZE) => {
    const { windowWidth } = useWindowSize();
    return windowWidth <= n;
};
